<template>
	<div id="zhuyinggoucheng" ><div v-if="showbtn">
		<div class="w95mg" >
			<h4 class="endsm_title">主营构成分析</h4>
		</div>
		<div class="land-ecahrt-title w95mg ">
			<span :class="mainTableType == 1 ? 'current title fl':'title fl'" @click="mainTableType=1;getCurDate()">主营收入</span>
			<span :class="mainTableType == 2 ? 'current title fl':'title fl'" @click="mainTableType=2;getCurDate()">主营成本</span>
			<span :class="mainTableType == 3 ? 'current title fl':'title fl'" @click="mainTableType=3;getCurDate()">利润比例</span>
			<!-- <select name="tableDate" v-model="curTableDate"  @change="getTableDate()">
							<option :value="list.date" v-for="list in tablelist">{{list.date}}</option>
						</select> -->
			<el-select v-model="curTableDate" class="curTableDate" @change="getCurDate" placeholder="时间选择" size="small">
				<el-option v-for="(item,index) in tablelist" :key="index" :label="item.date" :value="item.date"  />
			</el-select>
		</div>
		<div class="echartbox-block w95mg flexcss" >
			<div class="echart-box" id="mainPieProduct"></div>
			<div class="echart-box" id="mainPieArea"></div>
			<div class="echart-box" id="mainPieHy"></div>
		</div>
		<table border="0" cellspacing="0" cellpadding="0" class="pagetable1 w95mg" v-for="(list,i) in tablelist" :key="i">
			<tr>
				<th style="width: 200px;">{{list.date}}</th>
				<th style="width: 200px;">主营构成</th>
				<th>主营收入（元）</th>
				<th>收入比例</th>
				<th>主营成本（元）</th>
				<th>成本比例</th>
				<th>利润比例</th>
				<th>毛利率（%）</th>
			</tr>
			<tr  v-for="(item,index) in list.list" :key="index">
				<td v-if="item.grade == 1" :rowspan="item.rowspan">{{item.type}}分类</td>
				<td>{{item.name}}</td>
				<td>{{item.income}}</td>
				<td>{{item.incomeRatio}}%</td>
				<td>{{item.cost}}</td>
				<td>{{item.costRatio}}%</td>
				<td>{{item.profitRatio}}%</td>
				<td>{{item.maginRatio}}%</td>
			</tr>
		</table></div>
	</div>
</template>

<script>
	export default {
		name: 'zhuyinggoucheng',
		data() {
			return {
				titleh: "企业详情页的-主营构成-",
				pledgedata1: {},showbtn:false,
				tablelist: [],
				mainTableType: 1,
				echartWidth3: document.body.offsetWidth * 0.8728 * 0.95 * 0.32,
				curTableDate: "",
			}
		},
		props: {
			title: String,
			data: Object,

		},
		created() {

		},
		mounted() {
			// console.log('主营构成初始数值',this.data, this.data[0]);
			var firstData = this.data;
			// this.showbtn= this.data[0] != "undefined";
   // if(!this.showbtn){
			// 	return ;
			// }
			var tablelist = []; //提取相同时间
			for (var i in this.data) {
				this.showbtn=true;
				let lastarray = [];
				for (var d = 0; d < this.data[i].length; d++) {
					this.data[i][d].grade = 1, this.data[i][d].rowspan = 0;
				}
				for (var d = 0; d < this.data[i].length - 1; d++) {
					let smdata = this.data[i][d];
					if (smdata.type == this.data[i][d + 1].type) {
						this.data[i][d + 1].grade = 2;
					}
				}
				let testlist = [{
					type: this.data[i][0].type,
					list: [this.data[i][0]]
				}];
				for (var d = 1; d < this.data[i].length; d++) {
					let smdata = this.data[i][d];
					let len = testlist.length - 1;
					let oldname = testlist[len].type;
					if (oldname == this.data[i][d].type) {
						testlist[len].list.push(this.data[i][d]);
					} else {
						testlist.push({
							type: this.data[i][d].type,
							list: [this.data[i][d]]
						})
					}
				}
				for (var d = 0; d < testlist.length; d++) {
					for (var t = 0; t < testlist[d].list.length; t++) {
						let smlist2 = testlist[d].list[t];
						smlist2.rowspan = testlist[d].list.length;
						lastarray.push(smlist2);
					}
				}


				// console.log(testlist)
				let smlist = {
					date: i,
					list: lastarray
				};
				tablelist.push(smlist)
			}
			if(!this.showbtn){
				return;
			}
			this.tablelist = tablelist;
			this.curTableDate = tablelist[0].date;
			// console.log('主营构成初始数值2', tablelist);
			var _this=this;
			setTimeout(function(){
				_this.newfun(); 
			},2000)
   
		},
		methods: {
			getMoneyValue(data,unit){  
			 for(var i=0;i<data.length;i++){
					var val=data[i].value*1;
					var valUnit=data[i].unit;
					if(valUnit!=unit){
						 val=val*10000;
					} 
					if(data[i].value.indexOf('.')>0){
						data[i].value=val.toFixed(2)*1;
					} 
				} 
				return data;
			}, 
			newfun(){
				this.getCurDate();
			},
			getDataUnit(data){
				var unit='亿';
				for(var i=0;i<data.length;i++){
					if(unit != data[i].unit){
						unit='万';
					}
				};
				return unit;
			},
			getCurDate() {
				// console.log(this.curTableDate);
		  // console.log(this.mainTableType)
				var productdata = [],
					areadata = [],
					hydata = [],
					areaUnit='',	 
					productUnit='',
					hyUnit="";
					// var curdata=[];
					this.tablelist.forEach(list=>{ 
						if(list.date == this.curTableDate){
							var curdata=list.list; 
							for(var i=0;i<curdata.length;i++){
								var sml={name:curdata[i].name,value:0,unit:"",dvalue:0};
								if(this.mainTableType == 1){ 
									sml.value=curdata[i].income.substring(0,curdata[i].income.length - 1);
									sml.unit=curdata[i].income.charAt(curdata[i].income.length - 1);
									sml.dvalue=curdata[i].income;
								}else if(this.mainTableType == 2){ 
									sml.value=curdata[i].cost.substring(0,curdata[i].cost.length - 1);
									sml.unit=curdata[i].cost.charAt(curdata[i].cost.length - 1);
										sml.dvalue=curdata[i].cost;
								}else if(this.mainTableType == 3){
									sml.value=curdata[i].profitRatio; 
									sml.dvalue=curdata[i].profitRatio; 
								}  
								if(curdata[i].type == '按产品'){ 
									productdata.push(sml); 
								}else if(curdata[i].type == '按地区'){
									areadata.push(sml);  
								}else if(curdata[i].type == '按行业')
									hydata.push(sml);  
							} 
						}
					});
					var unit='万元';
					// incomeunit=curdata[0].income.charAt(curdata[0].income.length-1);costunit=curdata[0].cost.charAt(curdata[0].cost.length-1);
					// var istongyiUnit=true;
					// for(var d=0;d<curdata.length;d++){
					// 	if(incomeunit != curdata[i].income.charAt(curdata[i].income.length-1)){
					// 		incomeunit='万';
					// 	}
					// 	if(costunit != curdata[i].cost.charAt(curdata[i].cost.length-1)){
					// 		costunit='万';
					// 	} 
					// }
					
    // console.log(curdata)
				if(this.mainTableType == 3){
       productUnit="%";areaUnit="%";hyUnit="%";
				}else { 
					productUnit=this.getDataUnit(productdata);
					areaUnit=this.getDataUnit(areadata);
					hyUnit=this.getDataUnit(hydata);  
					productdata=this.getMoneyValue(productdata,productUnit);
					areadata=this.getMoneyValue(areadata,areaUnit);
					hydata=this.getMoneyValue(hydata,hyUnit);
				}
				// console.log(productdata,areadata,hydata);
				// console.log(productUnit,areaUnit,hyUnit);
				// return ;
				this.$nextTick(() => {
					this.mainPieFun('mainPieProduct', productdata, '按产品分类',productUnit);
					this.mainPieFun('mainPieArea', areadata, '按地区分类',areaUnit);
					this.mainPieFun('mainPieHy', hydata, '按行业分类',hyUnit);
				})
				
			},
			//
			mainPieFun(el, data, title,unit) {
  // console.log(title,data);
				var mypiechart = echarts.init(document.getElementById(el)); 
				mypiechart.showLoading({
					text: 'loading',
					color: '#3A568E',
					textColor: '#000',
					maskColor: 'rgba(255, 255, 255, 1)',
					zlevel: 1,
				});

				var option = {
					title: {
						text: title,
						left: 20,
						top: 10,
						textStyle:{
							color:'#666',fontWeight:'normal'
						}
					},
					//悬浮显示
					tooltip: {
					  trigger: 'item',
					  formatter: '{a} <br/>{b}: {c}'+unit+' ({d}%)'
					},
					// color: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
					//图例
					legend: {
						show: false,
						left: 'center',
						bottom: 10,
						itemWidth: 6,
						itemHeight: 6
					},

					series: [{
						name: '',
						type: 'pie',
						radius: '60%',
						data: data,
						label: {
							show: true,
							position: 'outside',
							color: '#000',
							fontSize: 12,
							formatter: '{b},{c}' + unit,
						},
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				};
				mypiechart.hideLoading();
				mypiechart.setOption(option);
			},
		}
	};
</script>

<style lang="scss" scoped>
	.pagetable1 {
		margin-bottom: 20px;
	}

	.endsm_title {
		border-left: 8px solid #3e7bfa;
		line-height: 20px;
		padding-left: 14px;
		margin: 10px 0 30px;
	}

	#mainPieProduct,
	#mainPieArea,
	#mainPieHy {
		width: 30%;
		height: 400px;
		background: #fff;
		border: 1px solid #eee;
	} 
	.curTableDate {
		width: 150px;
		margin-left: 100px;
	}
	.endsm_title {
			border-left: 8px solid #3e7bfa;
			line-height: 20px;
			padding-left: 14px;
			margin: 10px 0 30px;
		}
</style>